<form [formGroup]="form" class="flex flex-col gap-y-6">
  <div
    [ngClass]="{ 'g-control-invalid group': isValidationShouldBeShown(this.form.controls.businessDomain) }"
    e2e-render-type="dropdown"
    e2e-question-code="businessDomain"
  >
    <label id="businessDomain-label" for="businessDomain" cslLabel required class="mx-2 mb-1">Business Type</label>
    <csl-select
      id="businessDomain"
      placeholder="Choose business type"
      formControlName="businessDomain"
      aria-labelledby="businessDomain-label"
      [attr.aria-invalid]="isValidationShouldBeShown(this.form.controls.businessDomain) ? 'true' : null"
      [attr.aria-describedby]="
        isValidationShouldBeShown(this.form.controls.businessDomain) ? errorIds.businessDomain : null
      "
    >
      <div [cslOption]="null" [hidden]="true"></div>
      @for (item of BUSINESS_DOMAINS; track $index) {
        <div [cslOption]="item">{{ item }}</div>
      }
    </csl-select>
    @if (isValidationShouldBeShown(this.form.controls.businessDomain)) {
      <csl-validation-messages
        class="ml-1"
        [errors]="this.form.controls.businessDomain.errors"
        [attr.id]="errorIds.businessDomain"
        aria-live="polite"
      >
        <csl-validation-message name="required">
          {{ errorMessages.businessDomain['required'] }}
        </csl-validation-message>
      </csl-validation-messages>
    }
  </div>
  @if (this.form.controls.customDomain) {
    <div
      [ngClass]="{ 'g-control-invalid group': isValidationShouldBeShown(this.form.controls.customDomain) }"
      e2e-render-type="text-input"
      e2e-question-code="customDomain"
    >
      <label cslLabel [required]="true" for="customDomain" class="mx-2 mb-1">Specify Type</label>
      <input
        cslInput
        [cslInputPattern]="customDomainPattern"
        id="customDomain"
        type="text"
        placeholder="Specify business type"
        formControlName="customDomain"
        maxlength="32"
        [attr.aria-invalid]="isValidationShouldBeShown(this.form.controls.customDomain) ? 'true' : null"
        [attr.aria-describedby]="
          isValidationShouldBeShown(this.form.controls.customDomain) ? errorIds.customDomain : null
        "
      />

      @if (isValidationShouldBeShown(this.form.controls.customDomain)) {
        <csl-validation-messages
          class="ml-1"
          [errors]="this.form.controls.customDomain.errors"
          [attr.id]="errorIds.customDomain"
          aria-live="polite"
        >
          <csl-validation-message name="required">
            {{ errorMessages.customDomain['required'] }}
          </csl-validation-message>
          <csl-validation-message name="minlength">
            {{ errorMessages.customDomain['minlength'] }}
          </csl-validation-message>
          <csl-validation-message name="pattern"> {{ errorMessages.customDomain['pattern'] }} </csl-validation-message>
        </csl-validation-messages>
      }
    </div>
  }
  <div
    [ngClass]="{ 'g-control-invalid group': isValidationShouldBeShown(this.form.controls.companyName) }"
    e2e-render-type="text-input"
    e2e-question-code="companyName"
  >
    <label cslLabel [required]="true" for="companyName" class="mx-2 mb-1"> Company Name </label>
    <input
      cslInput
      [cslInputPattern]="companyNamePattern"
      id="companyName"
      type="text"
      placeholder="Enter company name"
      formControlName="companyName"
      maxlength="50"
      [attr.aria-invalid]="isValidationShouldBeShown(this.form.controls.companyName) ? 'true' : null"
      [attr.aria-describedby]="isValidationShouldBeShown(this.form.controls.companyName) ? errorIds.companyName : null"
    />

    @if (isValidationShouldBeShown(this.form.controls.companyName)) {
      <csl-validation-messages
        class="ml-1"
        [errors]="this.form.controls.companyName.errors"
        [attr.id]="errorIds.companyName"
        aria-live="polite"
      >
        <csl-validation-message name="required"> {{ errorMessages.companyName['required'] }} </csl-validation-message>
        <csl-validation-message name="minlength">
          {{ errorMessages.companyName['minlength'] }}
        </csl-validation-message>
      </csl-validation-messages>
    }
  </div>
</form>
